import { API_BASE } from "./serverApi";

const TIMEOUT_MS = 15000;

// Public endpoints: no auth header. Never throws; always resolves
// { ok, status, message, retryAfter, network }.
async function post(path, body) {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), TIMEOUT_MS);
  try {
    const res = await fetch(`${API_BASE}${path}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      signal: controller.signal,
    });
    let data = null;
    try {
      data = await res.json();
    } catch (e) {
      data = null;
    }
    const retryAfter =
      Number(data?.retryAfter) || Number(res.headers.get("Retry-After")) || 0;
    return {
      ok: res.ok && data?.success !== false,
      status: res.status,
      message: typeof data?.message === "string" ? data.message : "",
      retryAfter,
      network: false,
    };
  } catch (e) {
    return { ok: false, status: 0, message: "", retryAfter: 0, network: true };
  } finally {
    clearTimeout(timer);
  }
}

export const requestResetCode = (email) =>
  post("/api/auth/password-reset/request", { email });

export const confirmReset = (email, code, newPassword) =>
  post("/api/auth/password-reset/confirm", { email, code, newPassword });
